import React from 'react'
import withAuthentication from '../../containers/Authentication/withAuthentication';
import { withTranslation } from 'react-i18next';
import Button from '../../components/CustomButtons/Button'

// -----------------------Groups Table Header--------------------------//
const GroupsTableHeader = ({
    totalGroups,
    t
}) => {
  return (
    <div>
        <Button  color="info"
          round
          id="groupAddBtn"
        //   onClick={openAddWasherModal}
          style={{ marginRight: 5 }}>
          {t('Add Group')}
          </Button>
          <div style={{ textAlign: 'right' }}><b>{t('Total Groups')}: {totalGroups}</b></div>
    </div>
  )
}

export default withTranslation()(withAuthentication(GroupsTableHeader))

